import React, { useEffect, useRef, useState } from 'react';
import * as AutoAnimate from '@formkit/auto-animate';
import { navigate } from 'gatsby';

type BunnyFilterProps = {
  options: {
    name: string;
    label: string;
    to?: string;
  }[];
  setActiveType: (tag: string) => void;
  activeType: string;
  container: React.RefObject<HTMLDivElement>;
  theme?: string;
  isLink?: boolean;
};

const BunnyFilter: React.FC<BunnyFilterProps> = ({
  options,
  setActiveType,
  activeType,
  container,
  theme,
  isLink,
}) => {
  const getActiveClass = (name: string, activeType: string) =>
    activeType === name ? 'bunny-filter__item--active' : '';

  const getThemeClass = (theme?: string) =>
    theme ? `bunny-filter--${theme}` : '';

  const scrollRef = useRef<HTMLDivElement>(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);

  useEffect(() => {
    if (container.current) {
      AutoAnimate.default(container.current);
    }
  }, [container]);

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      scrollRef.current &&
      window.history.state?.scrollFilterX
    ) {
      scrollRef.current.scrollLeft = window.history.state.scrollFilterX;
    }
  }, []);

  const navigateToAnotherPage = (to: string) => {
    const scrollFilterX = scrollRef.current ? scrollRef.current.scrollLeft : 0;
    navigate(to, {
      state: {
        stopScroll: true,
        scrollFilterX,
      },
    });
  };

  useEffect(() => {
    const container = scrollRef.current;

    const onWheel = (e: WheelEvent) => {
      e.preventDefault();
      if (container) container.scrollLeft += e.deltaY;
    };

    if (container) {
      container.addEventListener('wheel', onWheel, { passive: false });
    }

    return () => {
      if (container) {
        container.removeEventListener('wheel', onWheel);
      }
    };
  }, []);

  // Check scroll position and update gradient visibility
  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    setShowLeft(el.scrollLeft > 0);
    console.log(el.scrollLeft + el.clientWidth < el.scrollWidth);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    checkScroll(); // initial check

    const onScroll = () => checkScroll();
    el.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onScroll);
    return () => {
      el.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <section className='block__filter block'>
      <div className='container relative !px-0'>
        <div
          ref={scrollRef}
          className={`bunny-filter ${getThemeClass(theme)}`}
        >
          {showLeft && <div className='gradient gradient-left' />}
          {showRight && <div className='gradient gradient-right' />}
          {options.map(option => {
            const activeOptionClass = getActiveClass(option.name, activeType);
            if (isLink) {
              return (
                <button
                  className={`bunny-filter__item ${activeOptionClass}`}
                  key={option.name}
                  onClick={() => navigateToAnotherPage(option.to || '')}
                >
                  {option.label}
                </button>
              );
            } else {
              return (
                <button
                  className={`bunny-filter__item ${activeOptionClass}`}
                  key={option.name}
                  onClick={() => setActiveType(option.name)}
                >
                  {option.label}
                </button>
              );
            }
          })}
        </div>
      </div>
    </section>
  );
};

export default BunnyFilter;
